<script>
import Boleto from "./Boleto";
import FAQ from "./FAQ";
import moment from "@/utils/moment";

import orderMixin from "@/mixins/orderMixin";
import freshDesk from "@/utils/freshDesk";
import { mapState } from "vuex";

export default {
  mixins: [orderMixin],
  props: {
    payable: {
      type: Object,
      required: true
    }
  },
  components: {
    Boleto,
    FAQ
  },
  data() {
    return {
      boleto: null
    };
  },
  methods: {
    getBoleto() {
      return this.payable.payments.find(
        payment =>
          payment.status === "waiting" &&
          payment.funding_instrument.type === "boletos"
      );
    },

    singularPayableType() {
      return this.payable.type.slice(0, -1);
    },

    buttonText() {
      return this.payable.type === "orders" ? "Ver pedido" : "Ver assinatura";
    },

    openFreshdesk() {
      freshDesk.openProofOfPaymentForm();
    }
  },
  computed: {
    showBoletoWarning() {
      return this.mustProvePayment(this.payable);
    }
  },
  mounted() {
    this.boleto = this.getBoleto();
  },
  watch: {
    payable() {
      this.boleto = this.getBoleto();
    }
  }
};
</script>

<template>
  <section class="pt-20 pb-20">
    <div class="success-content">
      <div class="success-icon"></div>

      <h2 v-if="boleto">SEU BOLETO ESTÁ PRONTO!</h2>
      <h2 v-else>SUA LIMPEZA FOI AGENDADA COM SUCESSO!</h2>
    </div>
    <div class="subtitle">Leia todas instruções abaixo!</div>

    <div v-if="showBoletoWarning" class="boleto-warning">
      <h4>VOCÊ PRECISA ENVIAR O COMPROVANTE</h4>
      <p>
        Para que a limpeza não seja cancelada,
        <b class="pointer" @click="openFreshdesk">clique aqui</b> e envie o comprovante de pagamento com até 48h úteis antes da limpeza.
      </p>
    </div>

    <boleto v-if="boleto" :boleto="boleto" />

    <div class="buttons">
      <router-link
        class="btn bg-pink"
        :to="{name: singularPayableType(), params: {id: payable.id}}"
      >{{buttonText()}}</router-link>
      <a
        href="https://api.whatsapp.com/send?text=Acabei%20de%20contratar%20uma%20diarista%20para%20fazer%20faxina%20pela%20plataforma%20Donamaid.%20Os%20profissionais%20s%C3%A3o%20avaliados%2C%20t%C3%AAm%20refer%C3%AAncia%20e%20levam%20os%20produtos%20de%20limpeza%21%20Use%20o%20cupom%20de%20desconto%20XHJD453%20para%20sua%20pr%C3%B3xima%20faxina%21%20www.donamaid.com"
        class="btn bg-green wpp"
        target="_blank"
        rel="noopener noreferrer"
      >
        Envie descontos para amigos
        <img src="\static\whatsapp_logo.svg" class="ml-10" />
      </a>
    </div>

    <p v-if="payable.type === 'orders'">
      O profissional acaba de ser notificado sobre esta nova limpeza. O seu pagamento ficará retido no
      Wirecard e só será enviado ao profissional após a limpeza. Caso o profissional cancele, você pode solicitar o reagendamento ou o reembolso.
    </p>

    <FAQ :rules="payable.type === 'orders'" :city="payable.address.district.city" />
  </section>
</template>

<style scoped>
section {
  align-items: unset !important;
}

.subtitle {
  text-align: center;
  font-size: 14px;
  margin-bottom: 20px;
}

.boleto-warning {
  color: var(--pink);
  text-align: center;
}

.boleto-warning a {
  color: var(--pink) !important;
}

.boleto-warning h4 {
  margin: 0 0 10px 0;
}

.boleto-warning p {
  margin: 0;
}

h2 {
  text-align: center;
}

p {
  font-size: 14px;
  text-align: justify;
  text-align-last: center;
}

.buttons,
.wpp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.buttons .btn {
  margin-left: 0;
  margin-right: 0;
}

.wpp {
  flex-direction: column-reverse;
}

.wpp img {
  height: 18px;
  margin-bottom: 10px;
}

.success-content {
  display: flex;
  justify-content: center;
}

.thank-you-text {
  border: 1px dashed var(--pink);
  border-radius: 5px;
  margin-bottom: 25px;
  padding-left: 8px;
  padding-right: 8px;
}

.thank-you-text p {
  color: #7d014d;
}

.success-icon {
  background: url("/static/icon-success.svg") center no-repeat;
  min-width: 25px;
  height: 20px;
  margin-right: 10px;
}

h2 {
  font-size: 18px;
  margin-bottom: 0;
  margin-top: 0;
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

ul li {
  padding: 3px 0;
}

.no-dots {
  list-style: none;
}

.no-dots img {
  transform: translateY(3px);
  margin-right: 3px;
}

.freshchat-icon {
  transform: translateY(5px);
}

.card {
  padding: 20px;
}

@media (min-width: 668px) {
  p {
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
  }

  .buttons,
  .wpp {
    flex-direction: row;
  }

  .buttons .btn {
    margin-left: 5px;
    margin-right: 5px;
  }

  .wpp img {
    height: 18px;
    margin-bottom: 0;
  }

  .success-icon {
    min-width: 80px;
    height: 25px;
    margin-right: 0;
  }

  h2 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Success.vue